export const isValidEmail = value => (
  value && /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)
);

export const isValidUrl = (value) => {
  let url;
  try {
    url = new URL(value);
  } catch (_) {
    return false;
  }

  return url.protocol && (url.protocol === 'http:' || url.protocol === 'https:');
};

export const isValidShareLinkSuffix = value => (
  value && /^[a-zA-Z0-9_-]+$/i.test(value)
);
